<template>
  <div class="grid grid-cols-5 gap-4">
    <Select
      v-model="selectedAssignee"
      :label="$t('general.assignee')"
      :placeholder="$t('general.none')"
      :auto-complete-collection="DATABASE_AUTOCOMPLETE_COLLECTION.User"
      :query-params="{
        rolloutIds: [rolloutId],
        role: [
          UserRole.TECHNICIAN,
          UserRole.ROLLOUT_MANAGER,
          UserRole.ADMINISTRATOR,
          UserRole.SERVICE_DESK,
        ],
      }"
      :class="isEditMode ? 'col-span-3' : 'col-span-5'"
      :disabled="disabled"
      :has-popover="false"
      user
      show-self-assign
    />
    <div
      v-if="isEditMode"
      class="col-span-2 cursor-pointer select-none text-right"
      @click="toggleTaskDone"
    >
      <Label class="cursor-pointer">
        {{ $t('inventory.tasks.task-is-done') }}
      </Label>
      <div class="flex h-9 items-center justify-end">
        <Toggle
          :model-value="isDone"
          :disabled="disabled"
          class="w-full justify-end"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { DebouncedFunc } from 'lodash';
import { debounce } from 'lodash';
import type { User } from '@/types';
import { DATABASE_AUTOCOMPLETE_COLLECTION } from '@/types';
import { UserRole } from '@/config/user-roles';

const props = defineProps({
  isDone: {
    type: Boolean,
    required: true,
  },
  rolloutId: {
    type: String,
  },
  assignee: {
    type: Object as PropType<User> | string | undefined,
  },
  isEditMode: {
    type: Boolean,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:isDone', 'update:assignee']);

const isDone = computed({
  get: () => props.isDone,
  set: (newValue) => emit('update:isDone', newValue),
});

const selectedAssignee = computed<User | undefined | string>({
  get: () => props.assignee ?? '',
  set: (newValue) => emit('update:assignee', newValue),
});

const toggleTaskDone: DebouncedFunc<() => void> = debounce(() => {
  if (!props.disabled) {
    isDone.value = !isDone.value;
  }
});
</script>
